<template>
  <div class="ui form" ref="form">
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <div class="field">
        <label for="">{{ $t("status") }}</label>
        <div class="ui toggle checkbox">
          <input type="checkbox" name="status" v-model="setup.status" />
          <label>{{ $t("is active?") }}</label>
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("auto-assign new bundles by default") }}</label>
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="auto_assign_bundles"
            v-model="setup.auto_assign_bundles"
          />
          <label>{{ $t("auto assign") }}</label>
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("allow code sent button") }}</label>
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="allow_code_sent_button"
            v-model="setup.allow_code_sent_button"
          />
          <label>{{ $t("is available?") }}</label>
        </div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("country") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="country_dropdown"
      >
        <input type="hidden" name="country" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select country") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div class="field" v-show="false">
      <label for="">{{ $t("phone number") }}</label>
      <input type="text" name="phone_number" v-model="setup.phone_number" />
    </div>
    <div class="field" v-show="false">
      <label for="">{{ $t("commercial email") }}</label>
      <input
        type="text"
        name="commercial_email"
        v-model="setup.commercial_email"
      />
    </div>
    <div class="field">
      <label for="">{{ $t("store email") }}</label>
      <input type="text" name="store_email" v-model="setup.store_email" />
    </div>
    <div class="field">
      <label for="">{{ $t("manager email") }}</label>
      <input type="text" name="manager_email" v-model="setup.manager_email" />
    </div>
    <div class="field">
      <label for="">{{ $t("associated users") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="users_dropdown"
      >
        <input type="hidden" name="users" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select users") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("manager users") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="managers_dropdown"
      >
        <input type="hidden" name="managers_users" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select users") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("type") }}</label>
      <div
        class="ui fluid multiple search selection dropdown"
        ref="type_dropdown"
      >
        <input type="hidden" name="type" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select type") }}</div>
        <div class="menu"></div>
      </div>
    </div>
    <div class="field">
      <label for="">{{ $t("availability") }}</label>
      <div class="field">
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="api_active"
            v-model="setup.is_api_active"
          />
          <label>{{ $t("api") }}</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="exchange_page_active"
            v-model="setup.is_exchange_page_active"
          />
          <label>{{ $t("exchange page") }}</label>
        </div>
      </div>
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
// import countries from "@/country.json";
import { countries } from "@/country.js";
import filters from "@/filters";

export default {
  name: "NvidiaBundleStoreModalGeneral",
  filters: filters,
  components: {},
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          country: ["empty"],
          // phone_number: ["empty"],
          // commercial_email: ["empty", "email"],
          manager_email: ["empty"],
          users: ["empty"],
          type: ["empty"],
        },
      });
    },
  },
  props: {},
  data() {
    return {
      setup: {
        name: "",
        country: "",
        phone_number: "",
        commercial_email: "",
        manager_email: "",
        store_email: "",
        associated_users: "",
        manager_users: "",
        type: "",
        logo: "",
        is_api_active: false,
        is_exchange_page_active: false,
        auto_assign_bundles: false,
        allow_code_sent_button: false,
        status: false,
      },
    };
  },
  methods: {
    setData(setup) {
      let vm = this;
      vm.setup = setup;
      if (setup.country) {
        let vls = setup.country.split(",");
        window.jQuery(vm.$refs.country_dropdown).dropdown("set selected", vls);
      }
      setTimeout(() => {
        if (setup.associated_users) {
          let vls = setup.associated_users.split(",");
          window.jQuery(vm.$refs.users_dropdown).dropdown("set selected", vls);
        }
        if (setup.manager_users) {
          let vls = setup.manager_users.split(",");
          window
            .jQuery(vm.$refs.managers_dropdown)
            .dropdown("set selected", vls);
        }
      }, 500);

      if (setup.type) {
        let vls = setup.type.split(",");
        window.jQuery(vm.$refs.type_dropdown).dropdown("set selected", vls);
      }
    },
    getData() {
      return this.setup;
    },
    isValid() {
      return this.form.form("validate form");
    },
  },
  mounted() {
    let vm = this;

    //Users dropdown
    local_api(vm, "post", "/user/do-get-all")
      .then(function(users) {
        let userVls = users.map((c) => {
          return { name: c.name, value: c.user_id };
        });
        window
          .jQuery(vm.$refs.users_dropdown)
          .dropdown("setup menu", { values: userVls })
          .dropdown({
            onChange(value) {
              vm.setup.associated_users = value;
              if (value) {
                let usrs = value.split(",");
                let u = usrs.map((usr) => {
                  let trgtUser = users.find((u) => {
                    return String(u.user_id) == String(usr);
                  });
                  return trgtUser;
                });

                let emails = u
                  .reduce((prev, curr) => {
                    return prev.concat([curr.email]);
                  }, [])
                  .join(",");
                vm.setup.store_email = emails;
              } else {
                vm.setup.store_email = "";
              }
            },
          });
        window
          .jQuery(vm.$refs.managers_dropdown)
          .dropdown("setup menu", { values: userVls })
          .dropdown({
            onChange(value) {
              vm.setup.manager_users = value;

              if (value) {
                let usrs = value.split(",");
                let u = usrs.map((usr) => {
                  let trgtUser = users.find((u) => {
                    return String(u.user_id) == String(usr);
                  });
                  return trgtUser;
                });

                let emails = u
                  .reduce((prev, curr) => {
                    return prev.concat([curr.email]);
                  }, [])
                  .join(",");
                vm.setup.manager_email = emails;
              } else {
                vm.setup.manager_email = "";
              }
            },
          });
      })
      .catch(function(err) {
        error_toast(err);
      });
    // window.jQuery(".ui.menu .item").tab();
    // console.log("mountedxx");
    setTimeout(() => {
      if (vm.setup_in) {
        // console.log("init graphic card");
        vm.setup = vm.setup_in;
        vm.id = vm.store_id;

        if (vm.setup.country) {
          let vls = vm.setup.country.split(",");
          window
            .jQuery(vm.$refs.country_dropdown)
            .dropdown("set selected", vls);
        }
        if (vm.setup.associated_users) {
          let vls = vm.setup.associated_users.split(",");
          window.jQuery(vm.$refs.users_dropdown).dropdown("set selected", vls);
        }
        if (vm.setup.type) {
          let vls = vm.setup.type.split(",");
          window.jQuery(vm.$refs.type_dropdown).dropdown("set selected", vls);
        }
      }
    }, 100);

    //Country dropdown
    let vls = countries.map((c) => {
      return { name: c.country, value: c.abbreviation };
    });
    window
      .jQuery(vm.$refs.country_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.setup.country = value;
        },
      });

    //Type dropdown
    let typeVls = ["Reseller", "Retail", "OEM", "Otro"].map((c) => {
      return { name: c, value: c };
    });
    window
      .jQuery(vm.$refs.type_dropdown)
      .dropdown("setup menu", { values: typeVls })
      .dropdown({
        onChange(value) {
          vm.setup.type = value;
        },
      });
  },
  watch: {},
  updated: function() {},
};
</script>
